import { VdsIcon, VdsTooltip } from '@volt/volt-extended-components-react';
import styles from './AssetIdentifier.module.scss';
import { hardwareTypeFromDto } from '@cas/utils/translationHelpers';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';

interface AssetIdentifierProps {
  showIcon?: boolean;
  name?: string;
  mismatch: boolean;
  deviceType: string;
  isCompact?: boolean;
}

export function AssetIdentifier({
  showIcon,
  name,
  mismatch,
  deviceType,
  isCompact,
}: AssetIdentifierProps) {
  const { t } = useTranslation();

  return (
    <div className={`${styles.container} ${isCompact && styles.compact}`}>
      {showIcon && (
        <VdsIcon
          size="32px"
          svgIcon="asset"
          color={mismatch ? 'red-500' : 'color-icon-information'}
        />
      )}
      <div className={styles.asset}>
        <div className={`${styles.name} ${mismatch && styles['name--bad']}`}>
          {name || <Skeleton width="100px" height="34px" />}
        </div>
        {mismatch && (
          <VdsTooltip
            id="sidepanel-asset-name-error"
            event="hover"
            max-width="150px"
            position="bottom"
            type="standard"
            text={t('AssetNameMismatch')}
          >
            <VdsIcon
              slot="tooltip-trigger"
              color="red-500"
              svgIcon="information"
              size={isCompact ? '20px' : '24px'}
            />
          </VdsTooltip>
        )}
      </div>
      <div className={styles.hardware}>{name && hardwareTypeFromDto(deviceType)}</div>
    </div>
  );
}

export default AssetIdentifier;
